import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanRoleRelationshipsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.GET_LOAN_ROLE_RELATIONSHIPS:
        return payload || state;

      case LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.CREATE_LOAN_ROLE_RELATIONSHIPS:
      case LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.EDIT_LOAN_ROLE_RELATIONSHIPS:
        draft[payload.id] = payload;
        break;

      case LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.DELETE_LOAN_ROLE_RELATIONSHIPS:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanRoleRelationshipsReducer;
